import { render, staticRenderFns } from "./UnsupportedBardEmail.vue?vue&type=template&id=454412c0&scoped=true"
import script from "./UnsupportedBardEmail.vue?vue&type=script&lang=js"
export * from "./UnsupportedBardEmail.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBardEmail.vue?vue&type=style&index=0&id=454412c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454412c0",
  null
  
)

export default component.exports